import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { TipoContrato } from 'src/app/Models/planilla/tipo-contrato';
import { DataService } from 'src/app/Service/data.service';

@Component({
  selector: 'app-tipo-contrato',
  templateUrl: './tipo-contrato.component.html',
  styleUrls: ['./tipo-contrato.component.css']
})
export class TipoContratoComponent implements OnInit {

  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;

  public search    = '';
  public page: any;
  public total     = 0;
  public items: TipoContrato[] = [];
  public nuevo: TipoContrato   = new TipoContrato();
  public agregando             = false;
  private _backup: {[id: number]: any} = {};

  constructor(private data: DataService, private title: Title) {}

  ngOnInit() {
    this.title.setTitle('Tipos de Contrato | Sistema');
    this.GetData();
  }

  GetData() {
    this.loading.show('Cargando...');
    this.items = [];
    const req = this.search
      ? this.data.GetFromValue(this.data.api.tipocontrato, 'nombre__icontains', this.search)
      : this.data.GetSimple(this.data.api.tipocontrato);
    req.subscribe(
      r => { this.loading.hide(); this.items = r; this.total = r.length; },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  ShowNew()   { this.nuevo = new TipoContrato(); this.agregando = true; }
  CancelNew() { this.agregando = false; this.nuevo = new TipoContrato(); }

  SaveNew() {
    this.loading.show('Registrando...');
    this.data.Post(this.data.api.tipocontrato, this.nuevo).subscribe(
      r => { this.loading.hide(); this.agregando = false; this.nuevo = new TipoContrato(); this.GetData(); },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  StartEdit(item: TipoContrato)  { this._backup[item.idtipocontrato] = { ...item }; item.editando = true; }
  CancelEdit(item: TipoContrato) { Object.assign(item, this._backup[item.idtipocontrato]); item.editando = false; }

  SaveEdit(item: TipoContrato) {
    this.loading.show('Actualizando...');
    this.data.Put(this.data.api.tipocontrato, `${item.idtipocontrato}`, item).subscribe(
      r => { this.loading.hide(); item.editando = false; delete this._backup[item.idtipocontrato]; },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  ShowDelete(item: TipoContrato) {
    this.info.show(`¿Deseas eliminar "${item.nombre}"?`, 1, null,
      { cancelText: 'No, Cancelar', successText: 'Sí, Eliminar', isCancel: true },
      () => this.Delete(item), () => { this.info.hide(); }, 20);
  }

  Delete(item: TipoContrato) {
    this.loading.show('Eliminando...');
    this.data.Delete(this.data.api.tipocontrato, `${item.idtipocontrato}`).subscribe(
      r => { this.loading.hide(); this.info.show(r.message, 2, null, null, () => { this.info.hide(); this.GetData(); }); },
      e => { this.loading.hide(); this.info.error(e, () => this.info.hide()); }
    );
  }
}
